import { Box, Flex, Text } from "@chakra-ui/react";
import { palette } from "./theme";

export const ChartLegend = ({ items }: { items: string[][] }): JSX.Element => (
  <Flex gap={4} wrap="wrap" mt={2} color={palette.label} fontSize="12px">
    {items.map(([label, color]) => (
      <Flex key={label} align="center" gap={2}>
        <Box w="14px" h="8px" borderRadius="full" bg={color} />
        <Text>{label}</Text>
      </Flex>
    ))}
  </Flex>
);
